<template>
  <figure
    class="flex gap-2 items-center font-semibold"
    :class="{ 'text-sm': size === 'small' }"
  >
    <app-user-avatar
      :avatar-url="user.avatar_url"
      class="h-(--height) !w-(--width)"
      :name="user.full_name"
      :size="avatarSize * 3"
      :style="{
        '--width': `${avatarSize}px`,
        '--height': `${avatarSize}px`,
      }"
    />

    <figcaption class="text-left">
      <p>{{ user.full_name }}</p>
      <p
        v-if="email"
        class="font-normal text-subtle text-sm"
        :class="{ '!text-xs': size === 'small' }"
      >
        {{ user.email }}
      </p>
    </figcaption>
  </figure>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    user: Pick<DatabaseTable<"users">, "full_name" | "avatar_url" | "email">;
    email?: boolean;
    avatarSize?: number;
    size?: "small";
  }>(),
  {
    email: true,
    avatarSize: 40,
    size: undefined,
  },
);
</script>
